import type { CrewTravelKind, CrewTravelStatus } from '../types';

export type CrewChangesCostPrintFilters = {
  tab?: 'all' | CrewTravelKind;
  vesselId?: string;
  status?: string;
  search?: string;
};

export function crewChangesCostPrintPath(filters: CrewChangesCostPrintFilters = {}): string {
  const qs = new URLSearchParams();
  if (filters.vesselId?.trim()) qs.set('vesselId', filters.vesselId.trim());
  if (filters.tab && filters.tab !== 'all') qs.set('kind', filters.tab);
  if (filters.status?.trim()) qs.set('status', filters.status.trim());
  if (filters.search?.trim()) qs.set('q', filters.search.trim());
  const q = qs.toString();
  return q ? `/crew/crew-changes-cost/print?${q}` : '/crew/crew-changes-cost/print';
}

export function crewChangesCostListApiUrl(params: URLSearchParams): string {
  const qs = new URLSearchParams();
  const vesselId = params.get('vesselId')?.trim();
  const kind = params.get('kind')?.trim();
  const status = params.get('status')?.trim();
  const q = params.get('q')?.trim();
  if (vesselId) qs.set('vesselId', vesselId);
  if (kind === 'CREW_CHANGE' || kind === 'VISIT') qs.set('kind', kind);
  if (status) qs.set('status', status);
  if (q) qs.set('q', q);
  const s = qs.toString();
  return `/crew/travels${s ? `?${s}` : ''}`;
}

export function crewChangesCostBackPath(params: URLSearchParams): string {
  // List page persists filters in local storage; vessel in URL is enough to restore focus.
  const vesselId = params.get('vesselId')?.trim();
  if (!vesselId) return '/crew/crew-changes-cost';
  return `/crew/crew-changes-cost`;
}

export function kindLabel(kind: CrewTravelKind): string {
  return kind === 'CREW_CHANGE' ? 'Changing crew' : 'Visit';
}

export function statusLabel(status: CrewTravelStatus): string {
  switch (status) {
    case 'DRAFT':
      return 'Draft';
    case 'BOOKED':
      return 'Booked';
    case 'ISSUED':
      return 'Issued';
    case 'CANCELLED':
      return 'Cancelled';
    default:
      return status;
  }
}
